<script setup lang="ts">
const route = useRoute();
const isAdminArea = computed(() => route.path.startsWith('/admin'));
const wrapper = computed(() => (isAdminArea.value ? 'div' : resolveComponent('UContainer')));
const wrapperClass = computed(() => (isAdminArea.value ? 'py-8 px-0 mx-8' : 'py-8 xl:px-12 lg:px-12 md:px-10 sm:px-10 px-8'));
</script>

<template>
  <component :is="wrapper" :class="wrapperClass">
    <slot />
  </component>
</template>
